import { render, staticRenderFns } from "./GlobalRefundRulesPage.vue?vue&type=template&id=d3da959e&scoped=true&"
import script from "./GlobalRefundRulesPage.vue?vue&type=script&lang=js&"
export * from "./GlobalRefundRulesPage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalRefundRulesPage.vue?vue&type=style&index=0&id=d3da959e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3da959e",
  null
  
)

export default component.exports